import { ChatStatusActionTypes, ChatStatusAction } from './types';

/**
 * todo: より直感的な名前にする
 */
export const defaultState = {
  initialLoading: true, // 初回ローディングしたかどうか。これはAPIの終了状況は見ていない
  loading: true, // settingなどチャットボットの設定データ取得が終わったかどうか。
  status: false, // チャットボット画面が表示(アイコンでない状態)かどうか。
  start: false, // statusが最初にtrueになった時だけログをとりたいので、それの判定に使う。
  hide: false // 非表示。アイコン <=> 拡大 の制御はstatus
};
export default function chatStatusReducer(
  state = defaultState,
  action: ChatStatusActionTypes
) {
  switch (action.type) {
    case ChatStatusAction.TOGGLE_CHATBOT:
      return {
        ...state,
        status: !state.status,
        start: true
      };
    case ChatStatusAction.HIDE_CHATBOT:
      return {
        ...state,
        hide: true
      };
    case ChatStatusAction.INITIAL_LOADING:
      return {
        ...state,
        initialLoading: false
      };
    case ChatStatusAction.LOADING_CHATBOT_END:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}
